import { useOutletContext } from 'react-router';
import Registered from './registered';
import NotRegistered from './notRegistered';

const Home = ({ handleHubChange, openAiCoachDialog }) => {
  const { user } = useOutletContext();

  return (
    <div className='max-w-lg mx-auto text-white'>
      {user.programRegistered ? (
        <Registered
          user={user}
          handleHubChange={handleHubChange}
          openAiCoachDialog={openAiCoachDialog}
        />
      ) : (
        <NotRegistered
          user={user}
          handleHubChange={handleHubChange}
        />
      )}
    </div>
  );
};

export default Home;
